import Button from "@/components/Button"
import Icons from "@/components/Icon"
import { MissionListItemProps } from "@/components/MissionList/MissionItem"
import content from "@/components/MissionList/MissionItem/data.json"
import style from "@/components/MissionList/MissionItem/style.scss"
import { getKey } from "@/components/util"
import _ from "lodash"
import { useRouter } from "next/router"
import React from "react"
import MissionItemBody from "../../MissionItemBody"

const Rejected: React.SFC<Readonly<MissionListItemProps>> = (props) => {
  const router = useRouter()
  const body = getKey(content, "rejected")
  const Icon = getKey(Icons, body.icon)

  const goToContact = () => {
    router.push("/support/contact")
  }

  return (
    <>
      <div className={style.content}>
        <div className={style.description}>
          {Icon && <Icon className={style.icon} />}

          <MissionItemBody
            mission={props.mission}
            title={body.title}
            description={body.description.replace(
              "%mission",
              `<strong>${props.mission.title}</strong>`
            )}
          />
        </div>

        <div className={style.actions}>
          <Button label="Contact" onClick={goToContact} />
        </div>
      </div>
    </>
  )
}

export default Rejected
